// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3764a","alert":"SettungsInbox_alert__NZ5UR"};